import BaseTabContainer from "components/base/BaseTabContainer";
import React from "react";
import { connect } from "react-redux";
import ReactHookFormTextInput from "components/reactHookFormComponents/ReactHookFormTextInput";
import MultipleInputWithTitle from "components/base/MultipleInputWithTitle";
import { useFormContext } from "react-hook-form";
import ReactHookFormTitleWithRadio from "components/reactHookFormComponents/ReactHookFormTitleWithRadio";
import { CustomInput } from "components/base/CustomTitleWithInput";
import ReactHookFormSwitch from "components/reactHookFormComponents/ReactHookFormSwitch";
import PeriodSection from "components/base/period/PeriodSection";
import { errorMessage, hasError } from "components/base/ErrorFieldMessage";
import { SectionTopTitle } from "components/base/CommonComponent";
import CustomTips from "components/base/CustomTips";

export const EARNING_RULE_PERIODIC_TYPE = {
  perDays: "PER_DAYS",
  specificTime: "SPECIFIC_TIME",
}

const PurchaseEarningRuleRewardLimitInputs = ({
  languages,
}) => {
  const { watch, setValue, formState: { errors } } = useFormContext()
  const tabNames = {
    earningRule: "Earning rule",
    perMember: "Per member",
    perTransaction: "Per transaction",
  }
  // tab: per transaction fields
  const perTransactionLimitCouponField = "perTransactionLimitCoupons";
  const perTransactionLimitPointsField = "perTransactionLimitPoints";
  const perTransactionLimitPpField = "perTransactionLimitPp";
  const perTransactionLimitStampsField = "perTransactionLimitStamps";

  // tab: earning rule fields
  const earningRuleAllTimeLimitCouponField = "earningRuleAllTimeLimitCoupons";
  const earningRuleAllTimeLimitPointsField = "earningRuleAllTimeLimitPoints";
  const earningRuleAllTimeLimitPpField = "earningRuleAllTimeLimitPp";
  const earningRuleAllTimeLimitStampsField = "earningRuleAllTimeLimitStamps";
  const earningRuleAllTimeLimitMaxTriggerTimesField = "earningRuleAllTimeLimitMaxTriggerTimes";

  const earningRuleTimePeriodLimitCouponField = "earningRuleTimePeriodLimitCoupons";
  const earningRuleTimePeriodLimitPointsField = "earningRuleTimePeriodLimitPoints";
  const earningRuleTimePeriodLimitPpField = "earningRuleTimePeriodLimitPp";
  const earningRuleTimePeriodLimitStampsField = "earningRuleTimePeriodLimitStamps";
  const earningRuleTimePeriodLimitMaxTriggerTimesField = "earningRuleTimePeriodLimitMaxTriggerTimes";

  const earningRuleTimePeriodLimitPeriodicTypeField = "earningRuleTimePeriodLimitPeriodicType";
  const earningRuleTimePeriodLimitPeriodicTypePerDaysField = "earningRuleTimePeriodLimitPeriodicTypePerDays";
  const earningRuleTimePeriodLimitPeriodicFollowActivePeriodField = "earningRuleTimePeriodLimitPeriodicFollowActive";
  const earningRuleTimePeriodLimitPeriodicStartTimeField = "earningRuleTimePeriodLimitPeriodicStartTime"
  const earningRuleTimePeriodLimitPeriodicEndTimeField = "earningRuleTimePeriodLimitPeriodicEndTime"

  // tab: per member fields
  const perMemberAllTimeLimitCouponField = "perMemberAllTimeLimitCoupons";
  const perMemberAllTimeLimitPointsField = "perMemberAllTimeLimitPoints";
  const perMemberAllTimeLimitPpField = "perMemberAllTimeLimitPp";
  const perMemberAllTimeLimitStampsField = "perMemberAllTimeLimitStamps";
  const perMemberAllTimeLimitMaxTriggerTimesField = "perMemberAllTimeLimitMaxTriggerTimes";

  const perMemberTimePeriodLimitCouponField = "perMemberTimePeriodLimitCoupons";
  const perMemberTimePeriodLimitPointsField = "perMemberTimePeriodLimitPoints";
  const perMemberTimePeriodLimitPpField = "perMemberTimePeriodLimitPp";
  const perMemberTimePeriodLimitStampsField = "perMemberTimePeriodLimitStamps";
  const perMemberTimePeriodLimitMaxTriggerTimesField = "perMemberTimePeriodLimitMaxTriggerTimes";

  const perMemberTimePeriodLimitPeriodicTypeField = "perMemberTimePeriodLimitPeriodicType";
  const perMemberTimePeriodLimitPeriodicTypePerDaysField = "perMemberTimePeriodLimitPeriodicTypePerDays";
  const perMemberTimePeriodLimitPeriodicFollowActivePeriodField = "perMemberTimePeriodLimitPeriodicFollowActivePeriod";
  const perMemberTimePeriodLimitPeriodicStartTimeField = "perMemberTimePeriodLimitPeriodicStartTime"
  const perMemberTimePeriodLimitPeriodicEndTimeField = "perMemberTimePeriodLimitPeriodicEndTime"

  const getAllTimeSection = (tab) => {
    if (![tabNames.earningRule, tabNames.perMember].includes(tab)) {
      return <></>
    }
    const maxTriggerTimesField = (
      tab === tabNames.earningRule
        ? earningRuleAllTimeLimitMaxTriggerTimesField
        : perMemberAllTimeLimitMaxTriggerTimesField
    );
    return (
      <div className="create-section-label-bottom-space global-setting-section-container">
        <div className="global-setting-section-title">{"All time "}</div>
        <div className="global-setting-section-content" style={{ maxWidth: "none" }}>
          <MultipleInputWithTitle
            title={"Maximum amount of rewards this earning rule can be issued in all time"}
            titleCustomClass={"create-section-label-no-top-space"}
            inputConfig={[
              {
                valueField: tab === tabNames.earningRule ? earningRuleAllTimeLimitCouponField : perMemberAllTimeLimitCouponField,
                unit: "Coupons",
              },
              {
                valueField: tab === tabNames.earningRule ? earningRuleAllTimeLimitPointsField : perMemberAllTimeLimitPointsField,
                unit: "Points",
              },
              {
                valueField: tab === tabNames.earningRule ? earningRuleAllTimeLimitPpField : perMemberAllTimeLimitPpField,
                unit: "Progression points",
              },
              {
                valueField: tab === tabNames.earningRule ? earningRuleAllTimeLimitStampsField : perMemberAllTimeLimitStampsField,
                unit: "Stamps",
              },
            ].map(item => ({
              value: watch(item.valueField),
              unit: item.unit,
              setValue: (value) => {
                setValue(item.valueField, value, { shouldDirty: true })
              },
              customClass: "width-160px",
              type: "number",
            }))}
          />
          <ReactHookFormTextInput
            type="number"
            title="Maximum number of times this earning rule can be triggered in all time"
            valueFieldName={maxTriggerTimesField}
            unit="times"
            customClass={"width-160px margin-right-10-percent"}
          />
        </div>
      </div>
    )

  }
  const getTimePeriodSection = (tab) => {
    if (![tabNames.earningRule, tabNames.perMember].includes(tab)) {
      return <></>
    }
    let timePeriodLimitPeriodicTypeField = earningRuleTimePeriodLimitPeriodicTypeField;
    let timePeriodLimitPeriodicFollowActivePeriodField = earningRuleTimePeriodLimitPeriodicFollowActivePeriodField;
    let perDayLimitField = earningRuleTimePeriodLimitPeriodicTypePerDaysField;
    let startTimeField = earningRuleTimePeriodLimitPeriodicStartTimeField;
    let endTimeField = earningRuleTimePeriodLimitPeriodicEndTimeField;
    if (tab === tabNames.perMember) {
      timePeriodLimitPeriodicTypeField = perMemberTimePeriodLimitPeriodicTypeField;
      timePeriodLimitPeriodicFollowActivePeriodField = perMemberTimePeriodLimitPeriodicFollowActivePeriodField;
      perDayLimitField = perMemberTimePeriodLimitPeriodicTypePerDaysField;
      startTimeField = perMemberTimePeriodLimitPeriodicStartTimeField;
      endTimeField = perMemberTimePeriodLimitPeriodicEndTimeField;
    }

    const showFollowActivePeriodSwitch = watch(timePeriodLimitPeriodicTypeField) === EARNING_RULE_PERIODIC_TYPE.specificTime
    const showTimePeriodInput = !watch(timePeriodLimitPeriodicFollowActivePeriodField)
    const maxTriggerTimesField = (
      tab === tabNames.earningRule
        ? earningRuleTimePeriodLimitMaxTriggerTimesField
        : perMemberTimePeriodLimitMaxTriggerTimesField
    );
    return (
      <div className="create-section-label-bottom-space global-setting-section-container">
        <div className="global-setting-section-title">{"WITHIN A TIME PERIOD"}</div>
        <div className="global-setting-section-content" style={{ maxWidth: "none" }}>
          <ReactHookFormTitleWithRadio
            customTitleClass="create-section-label-no-top-space"
            title={"Time period"}
            valueFieldName={timePeriodLimitPeriodicTypeField}
            defaultValue={EARNING_RULE_PERIODIC_TYPE.perDays}
            options={[
              {
                label: (
                  <CustomInput
                    per="Per"
                    unit={"days"}
                    inputCustomClass={"width-100px margin-right-10-percent"}
                    containerCustomClass={"d-flex"}
                    value={watch(perDayLimitField) || ""}
                    setValue={(value) => {
                      setValue(perDayLimitField, value, { shouldDirty: true })
                    }}
                  />),
                value: EARNING_RULE_PERIODIC_TYPE.perDays,
                customClass: "flex-align-item-center"
              },
              {
                label: 'Specific start and end time',
                value: EARNING_RULE_PERIODIC_TYPE.specificTime,
                customClass: "flex-align-item-center"
              },
            ]}
          />
          {showFollowActivePeriodSwitch &&
            <>
              <ReactHookFormSwitch
                title="Time period follow active period"
                valueFieldName={timePeriodLimitPeriodicFollowActivePeriodField}
              />
              <PeriodSection
                isAlwaysPeriod={!showTimePeriodInput}
                startDate={watch(startTimeField)}
                startDateChange={(date) => {
                  setValue(startTimeField, date, { shouldDirty: true });
                }}
                endDate={watch(endTimeField)}
                endDateChange={(date) => {
                  setValue(endTimeField, date, { shouldDirty: true });
                }}
                startErrorObject={{
                  id: startTimeField,
                  error: hasError(errors, startTimeField),
                  message: errorMessage(errors, startTimeField),
                }}
                endErrorObject={{
                  id: endTimeField,
                  error: hasError(errors, endTimeField),
                  message: errorMessage(errors, endTimeField),
                }}
              />
            </>

          }
          <MultipleInputWithTitle
            title={"Maximum amount of rewards this earning rule can be issued within a specified time period"}
            inputConfig={[
              {
                valueField: tab === tabNames.earningRule ? earningRuleTimePeriodLimitCouponField : perMemberTimePeriodLimitCouponField,
                unit: "Coupons",
              },
              {
                valueField: tab === tabNames.earningRule ? earningRuleTimePeriodLimitPointsField : perMemberTimePeriodLimitPointsField,
                unit: "Points",
              },
              {
                valueField: tab === tabNames.earningRule ? earningRuleTimePeriodLimitPpField : perMemberTimePeriodLimitPpField,
                unit: "Progression points",
              },
              {
                valueField: tab === tabNames.earningRule ? earningRuleTimePeriodLimitStampsField : perMemberTimePeriodLimitStampsField,
                unit: "Stamps",
              },
            ].map(item => ({
              value: watch(item.valueField),
              unit: item.unit,
              setValue: (value) => {
                setValue(item.valueField, value, { shouldDirty: true })
              },
              customClass: "width-160px",
              type: "number",
            }))}
          />
          <ReactHookFormTextInput
            type="number"
            title="Maximum number of times this earning rule can be triggered within a specified time period"
            valueFieldName={maxTriggerTimesField}
            unit="times"
            customClass={"width-160px margin-right-10-percent"}
          />
        </div>
      </div>
    )

  }
  const tabEerningRuleContent = (
    <div>
      {getAllTimeSection(tabNames.earningRule)}
      {getTimePeriodSection(tabNames.earningRule)}
    </div>
  )
  const tabPerMemberContent = (
    <div>
      {getAllTimeSection(tabNames.perMember)}
      {getTimePeriodSection(tabNames.perMember)}
    </div>
  )
  const tabPerTransactionContent = (
    <div>
      <div className="create-section-label-bottom-space global-setting-section-container">
        <div className="global-setting-section-content" style={{ maxWidth: "none" }}>
          <MultipleInputWithTitle
            titleCustomClass={"create-section-label-no-top-space"}
            title={"Maximum amount of rewards this earning rule can be issued per transaction"}
            inputConfig={[
              {
                valueField: perTransactionLimitCouponField,
                unit: "Coupons",
              },
              {
                valueField: perTransactionLimitPointsField,
                unit: "Points",
              },
              {
                valueField: perTransactionLimitPpField,
                unit: "Progression points",
              },
              {
                valueField: perTransactionLimitStampsField,
                unit: "Stamps",
              },
            ].map(item => ({
              value: watch(item.valueField),
              unit: item.unit,
              setValue: (value) => {
                setValue(item.valueField, value, { shouldDirty: true })
              },
              customClass: "width-160px",
              type: "number",
            }))}
          />
        </div>
      </div>
    </div>
  )


  const tabs = [
    {
      name: tabNames.earningRule,
      content: tabEerningRuleContent,
    },
    {
      name: tabNames.perMember,
      content: tabPerMemberContent,
    },
    {
      name: tabNames.perTransaction,
      content: tabPerTransactionContent,
    },
  ]
  return (
    <>
      <CustomTips 
        detail={
          `When a transaction exceed the maximum reward limit.
          If the reward is an one-off fixed amount reward, the reward will NOT be issued.
          If the reward is a dynamic amount reward, the reward will be issued based on the remaining reward quota.`
        }
      >
        <SectionTopTitle title={"REWARD LIMIT (OPTIONAL)"} />
      </CustomTips>
      <label className={`section-short-description`}>
        {"This section allows you to set the maximum limit under this earning rule. All fields are optional."}
      </label>
      <BaseTabContainer
        tabs={tabs}
      />
    </>
  )
}

const mapPropsToState = (state) => ({
  languages: state.language.allList,
});

export default connect(mapPropsToState)(PurchaseEarningRuleRewardLimitInputs);